export default __webpack_public_path__ + "static/media/kafeKrayon.1343deca.gif";